// TODO: Copied from Mobile Phones, clean up

(function () {
    'use strict';

    async function main() {
        var searchPage = wo$('[data-search-page]');
        if (!searchPage.length) return;

        var searchController = {
            init: async function () {
                searchController.registerNotifications();
                searchController.initHistoryTracker();

                wo$('[data-enable-when-ready]').removeAttr('disabled');

                await WhistleOut.bindSlick();
                searchController.registerPlanTypeLinks();
                WhistleOut.getAds('Tablets');
            },

            registerPlanTypeLinks() {
                var supplierPage = wo$('#browse-provider-page');
                if (!supplierPage.length) return;

                supplierPage.find('[data-plan-type-link]').click(function () {
                    var tab = wo$(this).data('plan-type-link');
                    if (!tab) return;

                    var tabButton = wo$.find('[data-tab-button="' + tab + '"]')[0];
                    if (!tabButton) return;

                    WhistleOut.scrollTo(tabButton);
                    tabButton.click();
                });
            },

            registerNotifications: function () {
                WhistleOut.notifications.add(function (notification, data) {
                    if (data && data.criteria) data.criteria.ShowAll = true;

                    if (notification === 'FilterChanged') {
                        var isAjax = data.type === 'Sort';
                        searchController.updateFilters(data.criteria, !isAjax);
                    }
                });
            },

            trackPage: function (criteria) {
                var values = [];
                values.push(criteria.currentsupplierid > 0 ? criteria.currentsupplierid : null);
                values.push(criteria.minSpend > -1 ? criteria.minSpend : null);
                values.push(criteria.maxSpend > -1 ? criteria.maxSpend : null);
                values.push(criteria.dealsonly);
                values.push(criteria.sortExpression);
                values.push(criteria.sortAscending);
                values.push(criteria.maxupfront > -1 ? criteria.maxupfront : null);
                var valuesString = values.join('|');
                WhistleOut.trackPageView(null, valuesString, true);
            },

            updateFilters: function (criteria, fullReload) {
                WhistleOut.startProgress('#search-results-partial', 0.1, 50);
                var queryString = '?';

                if (fullReload) {
                    criteria.hideEmptyTabs = false;
                    criteria.showAll = false;
                    criteria.showRowFilters = true;
                    criteria.hideWidenResults = false;
                    criteria.hideShare = false;
                    criteria.hideCoverage = false;
                    criteria.hideCoverageStrip = false;
                    criteria.maxResults = null;
                    criteria.maxResultsPerSupplier = null;
                    criteria.includefeatured = true;
                    criteria.enforceMaximumResultLimits = false;
                    criteria.productLabel = null;
                    searchController.trackPage(criteria);
                    queryString += WhistleOut.Tablets.generateQueryString(criteria);
                    location.href = criteria.searchUrl + queryString;
                    return;
                }

                queryString += WhistleOut.Tablets.generateQueryString(criteria);
                var resultsUrl = criteria.lines.length > 1 ? criteria.multiLineAjaxUrl : criteria.singleLineAjaxUrl;
                resultsUrl += queryString;

                wo$.ajax({
                    url: resultsUrl,
                    type: 'GET',
                    success: function (result) {
                        var $results = wo$('#search-results-partial');
                        $results.html(result);

                        WhistleOut.applyPopover($results);
                        WhistleOut.endProgress();
                        WhistleOut.notifications.fire('SearchResultsRendered');
                        searchController.trackPage(criteria);
                        wo$(window).resize();

                        wo$('[data-enable-when-ready]').removeAttr('disabled');
                    },
                    error: function () {
                        WhistleOut.endProgress();
                    }
                });
            },

            initHistoryTracker: function () {
                WhistleOut.initHistoryTracker(searchController);
            }
        };

        await searchController.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
